import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Header = (props) => {
  const headerType = props.headerType ? props.headerType : "";
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const accountDropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        accountDropdownRef.current &&
        !accountDropdownRef.current.contains(event.target)
      ) {
        setIsAccountDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleAccountDropdown = () => {
    setIsAccountDropdownOpen(!isAccountDropdownOpen);
  };

  const toggleMobileMenu = () => {
    const menu = document.getElementById("navigation");
    if (menu) {
      menu.classList.toggle("open");
      setIsMobileMenuOpen(!isMobileMenuOpen);
    }
  };

  // Function to handle submenu toggle on mobile
  const toggleMobileSubmenu = (e) => {
    if (window.innerWidth <= 991) {
      // Only on mobile
      e.preventDefault();
      const parent = e.target.closest(".has-submenu");
      if (parent) {
        parent.classList.toggle("open");
      }
    }
  };

  return (
    <React.Fragment>
      <>
        <header id="topnav" className="defaultscroll sticky header-dark">
          <div className="container">
            {/* Logo container*/}
            <Link className="logo" to="/">
              <img
                src="/images/logo.png"
                height={35}
                className="logo-light-mode"
                alt="Formax Pay"
              />
              <img
                src="/images/white-logo.png"
                height={35}
                className="logo-dark-mode"
                alt="Formax Pay"
              />
            </Link>
            {/* Logo End */}
            <div className="menu-extras">
              <div className="menu-item">
                {/* Mobile menu toggle*/}
                <a
                  className="navbar-toggle"
                  id="isToggle"
                  onClick={toggleMobileMenu}
                >
                  <div className="lines">
                    <span />
                    <span />
                    <span />
                  </div>
                </a>
                {/* End mobile menu toggle*/}
              </div>
            </div>

            {/* Login/Signup Dropdown Start */}
            <ul className="buy-button list-inline mb-0">
              <li
                className={`list-inline-item mb-0 ${
                  isAccountDropdownOpen ? "open" : ""
                }`}
                ref={accountDropdownRef}
              >
                <a
                  href="#"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleAccountDropdown();
                  }}
                >
                  <i className="uil uil-user me-1"></i> Account{" "}
                  <i className="uil uil-angle-down ms-1"></i>
                </a>
                {isAccountDropdownOpen && (
                  <div className="dropdown-menu show">
                    <div className="dropdown-account">
                      {/* User Account Section */}
                      <div className="dropdown-header">
                        <i className="uil uil-user-circle fs-5 me-2"></i> User
                        Account
                      </div>
                      <a
                        href="https://app.formaxpay.com/login"
                        target="_blank"
                        className="dropdown-item"
                        onClick={() => setIsAccountDropdownOpen(false)}
                      >
                        <i className="uil uil-signin fs-6 me-2"></i> User Login
                      </a>
                      <a
                        href="https://download.formaxpay.com/"
                        target="_blank"
                        className="dropdown-item"
                        onClick={() => setIsAccountDropdownOpen(false)}
                      >
                        <i className="uil uil-user-plus fs-6 me-2"></i> User
                        Sign Up
                      </a>
                      <div className="dropdown-divider"></div>

                      {/* Partner Account Section */}
                      <div className="dropdown-header">
                        <i className="uil uil-users-alt fs-5 me-2"></i> API
                        Partner Account
                      </div>
                      <Link
                        to="https://app.formaxpay.com/partner-login"
                        className="dropdown-item"
                        onClick={() => setIsAccountDropdownOpen(false)}
                      >
                        <i className="uil uil-signin fs-6 me-2"></i> Partner
                        Login
                      </Link>
                      <Link
                        to="https://app.formaxpay.com/partner-signup"
                        className="dropdown-item"
                        onClick={() => setIsAccountDropdownOpen(false)}
                      >
                        <i className="uil uil-user-plus fs-6 me-2"></i> Partner
                        Sign Up
                      </Link>
                    </div>
                  </div>
                )}
              </li>
            </ul>
            {/* Login/Signup Dropdown End */}

            <div id="navigation">
              <ul className="navigation-menu">
                {/* Home */}
                <li>
                  <Link to="/" className="sub-menu-item">
                    Home
                  </Link>
                </li>

                {/* Products */}
                <li className="has-submenu parent-menu-item">
                  <a href="javascript:void(0)" onClick={toggleMobileSubmenu}>
                    Products
                  </a>
                  <span
                    className="menu-arrow"
                    onClick={toggleMobileSubmenu}
                    style={{ cursor: "pointer" }}
                  />
                  <ul className="submenu">
                    <li>
                      <Link
                        to="/recharge-and-bill-payment"
                        className="sub-menu-item"
                      >
                        Recharge & BBPS Platform
                      </Link>
                    </li>
                    <li>
                      <Link to="/pan-card-services" className="sub-menu-item">
                        PAN Card Services
                      </Link>
                    </li>
                    <li>
                      <Link to="/insurance-posp" className="sub-menu-item">
                        Insurance POSP Platform
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* Solutions */}
                <li className="has-submenu parent-menu-item">
                  <a href="javascript:void(0)" onClick={toggleMobileSubmenu}>
                    Solutions
                  </a>
                  <span
                    className="menu-arrow"
                    onClick={toggleMobileSubmenu}
                    style={{ cursor: "pointer" }}
                  />
                  <ul className="submenu">
                    <li>
                      <Link to="" className="sub-menu-item">
                        Retail & MSME
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="sub-menu-item">
                        Startups & SaaS
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="sub-menu-item">
                        E-commerce Businesses
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="sub-menu-item">
                        Fintech & NBFCs
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="sub-menu-item">
                        Enterprises
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="sub-menu-item">
                        E-Governance & Agents
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* APIs – Mega Menu */}
                <li className="has-submenu parent-parent-menu-item">
                  <a href="javascript:void(0)" onClick={toggleMobileSubmenu}>
                    APIs
                  </a>
                  <span
                    className="menu-arrow"
                    onClick={toggleMobileSubmenu}
                    style={{ cursor: "pointer" }}
                  ></span>
                  <ul className="submenu megamenu">
                    <li>
                      <ul>
                        <li className="mega-title">Payment & Banking</li>
                        <li>
                          <Link
                            to="https://developers.formaxpay.com/get-authorization-17920814e0"
                            className="sub-menu-item"
                          >
                            Prepaid Gift Card API
                          </Link>
                        </li>
                        {/* <li>
                          <Link
                            to="https://developers.formaxpay.com/"
                            className="sub-menu-item"
                          >
                            Connected Banking
                          </Link>
                        </li> */}
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="mega-title">Recharge & BBPS</li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/recharge-api-6015309f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Mobile & DTH Recharge API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/recharge-api-6015309f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Utility Bill Payment API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/gift-voucher-api-6015334f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Gift Voucher API
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="mega-title">E-Governance & KYC</li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/uti-pan-card-api-6015329f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            UTI PAN Card API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/nsdl-e-kyc-pan-card-api-6015328f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            NSDL e-KYC PAN API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/pan-verification-26018357e0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Verification API
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="mega-title">Insurance & Leads</li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/credit-card-bank-account-demat-account-lead-api-6031808f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Insurance POSP API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/credit-card-bank-account-demat-account-lead-api-6031808f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Credit Card Lead API
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com/credit-card-bank-account-demat-account-lead-api-6031808f0"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Bank Account Lead API
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="mega-title">Developers</li>
                        <li>
                          <a
                            href="https://developers.formaxpay.com"
                            target="_blank"
                            className="sub-menu-item"
                          >
                            API Documentation
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://api.whatsapp.com/send/?phone=919836114520&text=Hello+Formax+Support%2C+I+need+help+with+Developer+API."
                            target="_blank"
                            className="sub-menu-item"
                          >
                            Developer Support
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                {/* Developers */}
                <li className="has-submenu parent-menu-item">
                  <a href="javascript:void(0)" onClick={toggleMobileSubmenu}>
                    Developers
                  </a>
                  <span
                    className="menu-arrow"
                    onClick={toggleMobileSubmenu}
                    style={{ cursor: "pointer" }}
                  />
                  <ul className="submenu">
                    <li>
                      <a
                        href="https://developers.formaxpay.com"
                        target="_blank"
                      >
                        API Documentation
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://api.whatsapp.com/send/?phone=919836114520&text=Hello+Formax+Developer+Support"
                        target="_blank"
                      >
                        Developer Support
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Company */}
                <li className="has-submenu parent-menu-item">
                  <a href="javascript:void(0)" onClick={toggleMobileSubmenu}>
                    Company
                  </a>
                  <span
                    className="menu-arrow"
                    onClick={toggleMobileSubmenu}
                    style={{ cursor: "pointer" }}
                  />
                  <ul className="submenu">
                    <li>
                      <Link to="/about-formax-pay" className="sub-menu-item">
                        About Formax Pay
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us" className="sub-menu-item">
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/compliance-and-security"
                        className="sub-menu-item"
                      >
                        Compliance & Security
                      </Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy" className="sub-menu-item">
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/terms-and-conditions"
                        className="sub-menu-item"
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </header>

        <style>{`
          /* White header styles for gradient background */
          .header-dark {
            background: transparent !important;
            box-shadow: none !important;
          }
          
          .header-dark #navigation .navigation-menu > li > a,
          .header-dark #navigation .navigation-menu > li > .sub-menu-item,
          .header-dark #navigation .navigation-menu > li.has-submenu > a {
            color: rgba(255, 255, 255, 0.9) !important;
          }
          
          .header-dark #navigation .navigation-menu > li > a:hover,
          .header-dark #navigation .navigation-menu > li > .sub-menu-item:hover,
          .header-dark #navigation .navigation-menu > li.has-submenu > a:hover {
            color: #ffffff !important;
          }
          
          .header-dark .menu-arrow {
            border-color: rgba(255, 255, 255, 0.9) !important;
          }
          
          .header-dark .navbar-toggle .lines span {
            background: #ffffff !important;
          }
          
          .header-dark .navbar-toggle .lines:before,
          .header-dark .navbar-toggle .lines:after {
            background: #ffffff !important;
          }
          
          /* Dropdown menu styles */
          .header-dark #navigation .submenu,
          .header-dark #navigation .megamenu {
            background: #ffffff !important;
            border: none !important;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
          }
          
          .header-dark #navigation .submenu li a,
          .header-dark #navigation .megamenu li a {
            color: #333333 !important;
          }
          
          .header-dark #navigation .submenu li a:hover,
          .header-dark #navigation .megamenu li a:hover {
            color: #4a6cf7 !important;
            background: #f8f9fa !important;
          }
          
          .megamenu .mega-title {
            color: #4a6cf7 !important;
            font-weight: 600;
            padding: 8px 12px;
            text-transform: uppercase;
            font-size: 0.75rem;
            letter-spacing: 0.5px;
            pointer-events: none;
          }
          
          /* Account dropdown styles */
          .header-dark .buy-button .dropdown-menu {
            background: #ffffff !important;
            border: none !important;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
          }
          
          .header-dark .buy-button .dropdown-item {
            color: #333333 !important;
          }
          
          .header-dark .buy-button .dropdown-item:hover {
            color: #4a6cf7 !important;
            background: #f8f9fa !important;
          }
          
          .header-dark .dropdown-header {
            color: #4a6cf7 !important;
            font-weight: 600;
          }
          
          /* Mobile menu styles */
          @media (max-width: 991px) {
            .header-dark #navigation {
              background: #ffffff !important;
            }
            
            .header-dark #navigation .navigation-menu > li > a,
            .header-dark #navigation .navigation-menu > li > .sub-menu-item,
            .header-dark #navigation .navigation-menu > li.has-submenu > a {
              color: #333333 !important;
              cursor: pointer;
            }
            
            .header-dark #navigation .submenu li a,
            .header-dark #navigation .megamenu li a {
              color: #666666 !important;
            }
            
            /* Mobile submenu styles */
            .header-dark #navigation .has-submenu .submenu,
            .header-dark #navigation .has-submenu .megamenu {
              display: none;
              position: static;
              box-shadow: none;
              background: transparent;
              padding-left: 20px;
              width: 100%;
            }
            
            .header-dark #navigation .has-submenu.open .submenu,
            .header-dark #navigation .has-submenu.open .megamenu {
              display: block;
            }
            
            .header-dark #navigation .has-submenu .menu-arrow {
              position: absolute;
              right: 0;
              top: 12px;
              width: 5px;
              height: 5px;
              transform: rotate(45deg);
              border: solid #333;
              border-width: 0 2px 2px 0;
              display: inline-block;
              padding: 3px;
              transition: transform 0.3s ease;
            }
            
            .header-dark #navigation .has-submenu.open .menu-arrow {
              transform: rotate(-135deg);
              top: 18px;
            }
            
            /* Mega menu adjustments for mobile */
            .header-dark #navigation .megamenu {
              display: flex;
              flex-direction: column;
            }
            
            .header-dark #navigation .megamenu > li {
              width: 100%;
              margin-bottom: 20px;
            }
            
            .header-dark #navigation .megamenu > li > ul {
              padding: 0;
            }
            
            .header-dark #navigation .megamenu .mega-title {
              background: #f8f9fa;
              padding: 10px 15px;
              margin-bottom: 10px;
              border-radius: 4px;
            }
          }
          
          /* Make sure logo is white */
          .header-dark .logo img {
            filter: brightness(0) invert(1);
          }
          
          /* Sticky state - when scrolling */
          .sticky.header-dark {
            background: rgba(255, 255, 255, 0.95) !important;
            backdrop-filter: blur(10px);
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
          }
          
          .sticky.header-dark #navigation .navigation-menu > li > a,
          .sticky.header-dark #navigation .navigation-menu > li > .sub-menu-item,
          .sticky.header-dark #navigation .navigation-menu > li.has-submenu > a {
            color: #333333 !important;
          }
          
          .sticky.header-dark .logo img {
            filter: none !important;
          }
          
          .sticky.header-dark .menu-arrow {
            border-color: #333333 !important;
          }
          
          .sticky.header-dark .navbar-toggle .lines span {
            background: #333333 !important;
          }
          
          .sticky.header-dark .navbar-toggle .lines:before,
          .sticky.header-dark .navbar-toggle .lines:after {
            background: #333333 !important;
          }
        `}</style>
      </>
    </React.Fragment>
  );
};

export default Header;
